module.exports = __webpack_public_path__ + "img/marcador.6dad2912.svg";